"use client"
/* */
const complexityIndicator = "flow--password-creation-field--complexity-indicator";
const hide = "flow--password-creation-field--complexity-indicator--hide";
const bar = "flow--password-creation-field--complexity-indicator--bar";
const running = "flow--password-creation-field--complexity-indicator--running";
const loading = "flow--password-creation-field--complexity-indicator--loading";
const shimmer = "flow--password-creation-field--complexity-indicator--shimmer";
const styles = {
	complexityIndicator: complexityIndicator,
	hide: hide,
	bar: bar,
	running: running,
	"bar-background-status-danger": "flow--password-creation-field--complexity-indicator--bar-background-status-danger",
	"bar-background-status-success": "flow--password-creation-field--complexity-indicator--bar-background-status-success",
	"bar-background-status-warning": "flow--password-creation-field--complexity-indicator--bar-background-status-warning",
	"bar-background-status-indeterminate": "flow--password-creation-field--complexity-indicator--bar-background-status-indeterminate",
	loading: loading,
	shimmer: shimmer
};

export { bar, complexityIndicator, styles as default, hide, loading, running, shimmer };
//# sourceMappingURL=ComplexityIndicator.module.scss.mjs.map
